import React, { useState } from 'react';

function Compare({ products, category, loading }) {
  const [selectedProducts, setSelectedProducts] = useState([]);

  const toggleProduct = (product) => {
    if (selectedProducts.find(p => p.id === product.id)) {
      setSelectedProducts(selectedProducts.filter(p => p.id !== product.id));
    } else {
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  return (
    <div id="cm">
      <div style={{ marginBottom: '12px' }}>
        <h3 style={{ fontSize: '13px', fontWeight: '700', marginBottom: '8px', color: '#374151' }}>
          Select products to compare
        </h3>
        <div className="SG">
          {products.map(product => (
            <div
              key={product.id}
              className="si"
              onClick={() => toggleProduct(product)}
              style={{
                borderColor: selectedProducts.find(p => p.id === product.id) ? product.color : '#E5E7EB',
                background: selectedProducts.find(p => p.id === product.id) ? `${product.color}08` : '#FAFBFC'
              }}
            >
              <div>
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#111827' }}>
                  {product.code}
                </div>
                <div style={{ fontSize: '8px', color: '#6B7280' }}>
                  {product.name}
                </div>
              </div>
              <div style={{
                width: '16px',
                height: '16px',
                borderRadius: '3px',
                border: `2px solid ${selectedProducts.find(p => p.id === product.id) ? product.color : '#D1D5DB'}`,
                background: selectedProducts.find(p => p.id === product.id) ? product.color : '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                color: '#fff',
                fontWeight: '700'
              }}>
                {selectedProducts.find(p => p.id === product.id) ? '✓' : ''}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProducts.length > 0 && (
        <div className="TW">
          <table>
            <thead>
              <tr>
                <th>Property</th>
                {selectedProducts.map(product => (
                  <th key={product.id} style={{ background: `${product.color}10` }}>
                    <div style={{ fontSize: '9px', fontWeight: '800', color: product.color }}>
                      {product.code}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Package</td>
                {selectedProducts.map(product => (
                  <td key={product.id}>{product.package_number}</td>
                ))}
              </tr>
              <tr>
                <td>Name</td>
                {selectedProducts.map(product => (
                  <td key={product.id}>{product.name}</td>
                ))}
              </tr>
              <tr>
                <td>API Spec</td>
                {selectedProducts.map(product => (
                  <td key={product.id}>{product.api_spec}</td>
                ))}
              </tr>
              <tr>
                <td>TBN</td>
                {selectedProducts.map(product => (
                  <td key={product.id}>{product.tbn}</td>
                ))}
              </tr>
              <tr>
                <td>Treat Rate (%)</td>
                {selectedProducts.map(product => (
                  <td key={product.id}>{product.treat_rate}</td>
                ))}
              </tr>
              <tr>
                <td>Ash (%)</td>
                {selectedProducts.map(product => (
                  <td key={product.id}>{product.ash || '—'}</td>
                ))}
              </tr>
              {selectedProducts.some(p => p.tbn_in_oil && p.tbn_in_oil > 0) && (
                <tr>
                  <td>TBN in Oil</td>
                  {selectedProducts.map(product => (
                    <td key={product.id}>{(product.tbn_in_oil && product.tbn_in_oil > 0) ? product.tbn_in_oil : '—'}</td>
                  ))}
                </tr>
              )}
              <tr>
                <td>EXW Bulk ($)</td>
                {selectedProducts.map(product => {
                  const price = product.user_price || {
                    exw_bulk_price: product.exw_bulk_price
                  };
                  return <td key={product.id}>{price.exw_bulk_price}</td>;
                })}
              </tr>
              <tr>
                <td>EXW IBC ($)</td>
                {selectedProducts.map(product => {
                  const price = product.user_price || {
                    exw_ibc_price: product.exw_ibc_price
                  };
                  return <td key={product.id}>{price.exw_ibc_price}</td>;
                })}
              </tr>
              <tr>
                <td>Cost in Oil ($/MT)</td>
                {selectedProducts.map(product => {
                  const price = product.user_price || {
                    cost_in_oil: product.cost_in_oil
                  };
                  return <td key={product.id}>{price.cost_in_oil}</td>;
                })}
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {selectedProducts.length === 0 && (
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          color: '#9CA3AF',
          fontSize: '12px'
        }}>
          Select products above to compare their properties
        </div>
      )}
    </div>
  );
}

export default Compare;
